const stringSimilarity = require("string-similarity");
const Vue = require("vue");

Vue.component("questionTrivia", {
  props: ["answer", "total"],
  data: function () {
    return {
      isAnswered: false,
      isCorrect: false,
      free: "",
      count: 0,
      countCorrect: 0,
      credit: 1,
    };
  },
  methods: {
    removeAnswer(value) {
      this.count--;
      if (value) this.countCorrect--;

      this.isAnswered = this.count === this.total;
      this.isCorrect = this.countCorrect === this.total;
    },

    countAnswers(valid) {
      if (this.isAnswered) return;

      this.count++;
      if (valid) this.countCorrect++;

      this.isAnswered = this.count === this.total;
      this.isCorrect = this.countCorrect === this.total;

      if (this.isAnswered) {
        this.$emit("update-result", this.isCorrect ? this.credit : 0);
        this.scrollToNextQuestion();
      }
    },

    checkFreeAnswer(e) {
      if (this.isAnswered || !e.target.value.length) return;

      let answer = e.target.value
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/`/g, " ")
        .replace(/'/g, " ");

      for (let i = 0; i < this.answer.length; i++) {
        let compare = this.answer[i]
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/`/g, " ")
          .replace(/'/g, " ");

        let exact = compare[0] === "!";
        if (exact) compare = compare.substring(1);

        let similarity = stringSimilarity.compareTwoStrings(answer, compare);
        if ((exact && similarity === 1) || (!exact && similarity >= 0.8)) {
          this.isCorrect = true;
          break;
        }
      }

      this.isAnswered = true;
      this.$emit("update-result", this.isCorrect ? this.credit : 0);
      this.scrollToNextQuestion();
    },

scrollToNextQuestion() {
  this.$nextTick(() => {
    const current = this.$el;
    let next = current;

    while (next && (next = next.nextElementSibling)) {
      if (next.classList.contains("m-question")) {
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;
        const adOffset = 200;

        const top =
          next.getBoundingClientRect().top +
          window.scrollY -
          headerHeight -
          adOffset;

        window.scrollTo({ top, behavior: "smooth" });
        break;
      }
    }
  });
}
  },
});
